/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../DataProvider";
import * as widgets from "./Widget";
import * as customWidgets from "../CustomWidgets";

const DEFAULT_WIDGET = "ViewText";

function upperCaseFirst(value) {
    return value[0].toUpperCase() + value.slice(1);
}

class DataWidget extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        type: PropTypes.oneOf(["view", "edit"]),
        field: PropTypes.string
    };

    static defaultProps = {
        type: "view"
    };

    constructor(props) {
        super(props);
        this.state = {};
        /**
         * @var {DataProvider} this.props.dataProvider
         */
    }

    getWidgetComponent() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;
        let schema = dataProvider.getSchema().field(this.props.field);
        let widget = schema.getSchemaElement("widget");
        let widgetName = null;
        if (!widget) widgetName = this.getWidgetFromType(this.props.type, schema.getType(), schema.getFormat());
        else widgetName = upperCaseFirst(this.props.type) + upperCaseFirst(widget);

        let widgetComponent = customWidgets[widgetName];
        if (!widgetComponent) widgetComponent = widgets[widgetName];
        if (!widgetComponent) widgetComponent = widgets[DEFAULT_WIDGET];
        return widgetComponent;
    }

    /**
     *
     * @param {string} viewType
     * @param {string} fieldType
     * @param {string} fieldFormat
     * @returns {string}
     */
    getWidgetFromType(viewType, fieldType, fieldFormat) {
        switch (fieldType) {
            case "object":
                return "ViewObject";
            case "array":
                return "ViewArray";
            case "string":
                switch (fieldFormat) {
                    case "email":
                        return "ViewEmail";
                    default:
                        return "ViewText";
                }
            default:
                return "ViewText";
        }
    }

    render() {
        let WidgetComponent = this.getWidgetComponent();
        return (<WidgetComponent dataProvider={this.props.dataProvider} field={this.props.field} />);
    }
}

export default DataWidget;
